import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from '@nosto/preact'
import { useState } from 'preact/hooks'

export default function Product({ product }) {
    const { format } = useCurrencyFormatting()
    const [primaryImageLoaded, setPrimaryImageLoaded] = useState(false)

    const productHandle = product.url.split('/').pop()
    const productType = product.customFields?.find((field) => field.key === 'producttype')?.value

    return (
        <SerpElement
            as="product-card"
            hit={product}
            class="product-card nosto-product-info"
            x-nosto-handle={productHandle}
            handle={productHandle}
            reveal-on-scroll="true">
            <div class="product-card__figure">
                {product.availability !== 'InStock' && (
                    <badge-list class="badge-list">
                        <sold-out-badge class="badge badge--sold-out">
                            {productType && productType.toLowerCase() === 'original' ? 'Sold' : 'Sold out'}
                        </sold-out-badge>
                    </badge-list>
                )}
                <a
                    href={product.url}
                    class={`nosto-product-url product-card__media ${
                        primaryImageLoaded ? 'images-loaded' : ''
                    }`}
                    draggable="false">
                    <img
                        src={product.imageUrl.replace(/_\d+x\d+/, '_1280x1280')}
                        alt={product.name}
                        srcSet={`
                            ${product.imageUrl.replace(/_\d+x\d+/, '_200x200')}   200w,
                            ${product.imageUrl.replace(/_\d+x\d+/, '_300x300')}   300w,
                            ${product.imageUrl.replace(/_\d+x\d+/, '_400x400')}   400w,
                            ${product.imageUrl.replace(/_\d+x\d+/, '_500x500')}   500w,
                            ${product.imageUrl.replace(/_\d+x\d+/, '_600x600')}   600w,
                            ${product.imageUrl.replace(/_\d+x\d+/, '_700x700')}   700w,
                            ${product.imageUrl.replace(/_\d+x\d+/, '_800x800')}   800w,
                            ${product.imageUrl.replace(/_\d+x\d+/, '_1000x1000')} 1000w,
                            ${product.imageUrl.replace(/_\d+x\d+/, '_1200x1200')} 1200w
                        `}
                        sizes="(max-width: 699px) calc(100vw / 2), (max-width: 999px) calc(100vw - 64px), calc((100vw - 96px) / 3 - (24px / 3 * 2))"
                        width="1280"
                        height="1280"
                        draggable="false"
                        onLoad={() => setPrimaryImageLoaded(true)}
                        class="product-card__image product-card__image--primary aspect-square"
                    />
                    {Array.isArray(product.alternateImageUrls) && product.alternateImageUrls[0] && (
                        <img
                            src={product.alternateImageUrls[0]}
                            alt={product.name}
                            srcSet={`
                            ${product.alternateImageUrls[0].replace(/_\d+x\d+/, '_200x200')}   200w,
                            ${product.alternateImageUrls[0].replace(/_\d+x\d+/, '_300x300')}   300w,
                            ${product.alternateImageUrls[0].replace(/_\d+x\d+/, '_400x400')}   400w,
                            ${product.alternateImageUrls[0].replace(/_\d+x\d+/, '_500x500')}   500w,
                            ${product.alternateImageUrls[0].replace(/_\d+x\d+/, '_600x600')}   600w,
                            ${product.alternateImageUrls[0].replace(/_\d+x\d+/, '_700x700')}   700w,
                            ${product.alternateImageUrls[0].replace(/_\d+x\d+/, '_800x800')}   800w,
                            ${product.alternateImageUrls[0].replace(/_\d+x\d+/, '_1000x1000')} 1000w,
                            ${product.alternateImageUrls[0].replace(/_\d+x\d+/, '_1200x1200')} 1200w
                        `}
                            sizes="(max-width: 699px) calc(100vw / 2), (max-width: 999px) calc(100vw / 0 - 64px), calc((100vw - 96px) / 3 - (24px / 3 * 2))"
                            width="1280"
                            height="1280"
                            loading="lazy"
                            fetchpriority="low"
                            draggable="false"
                            class="product-card__image product-card__image--secondary"
                        />
                    )}
                </a>
            </div>
            <div class="product-card__info heading-color empty:hidden">
                <div class="product_card__info__content">
                    <a href={product.url} class="nosto-product-url product-title">
                        {product.name}
                    </a>
                    {productType ? (
                        <p class="text-subdued text-xs">
                            {product.brand} | {productType}
                        </p>
                    ) : (
                        <p class="text-subdued text-xs">{product.brand}</p>
                    )}
                </div>
                <price-list class="price-list">
                    <sale-price>
                        <span class="sr-only">Sale price</span>
                        <span class="nosto-price">{product.priceText}</span>
                    </sale-price>
                    {product.listPrice > product.price && (
                        <compare-at-price class="text-subdued line-through text-xs">
                            <span class="sr-only">Regular price</span>
                            <span class="nosto-list-price">{product.listPriceText}</span>
                        </compare-at-price>
                    )}
                </price-list>
            </div>
        </SerpElement>
    )
}
